@for (menu of parentMenu; track menu) {
  <div class="menu-item">
    @if (menu.subcategories.length==0) {
      <a mat-button
        fxLayout="row" fxLayoutAlign="space-between center"
        (click)="goToCategory(menu)" [id]="'menu-item-'+menu.categoryId">
        <span class="menu-title" style="font-family: var(--website-font-family);">{{ menu.categoryName  }}</span>
      </a>
    }
    @if (menu.subcategories.length>0) {
      <a mat-button
        fxLayout="row" fxLayoutAlign="space-between center"
        (click)="onClick(menu.categoryId,menu.parentId,menu.subcategories)" [id]="'menu-item-'+menu.categoryId">
        <span class="menu-title font"  >{{ menu.categoryName  }}</span>
        @if (isExpanded(menu.categoryId)) {
          <mat-icon class="menu-expand-icon transition-2 menu-expand-icon1" >keyboard_arrow_down</mat-icon>
        }
        @if (!isExpanded(menu.categoryId)) {
          <mat-icon  class="menu-expand-icon transition-2" >keyboard_arrow_down</mat-icon>
        }
      </a>
    }
    @if (menu.subcategories.length>0) {
      <div class="sub-menu" [id]="'sub-menu-'+menu.categoryId" [style.marginLeft.px]="depth < 2 ? 15 : 0" >
        <calsoft-side-bar-child-popup [menuItems]="menu.subcategories" [menuParentId]="menu.categoryId"  [depth]="depth + 1"></calsoft-side-bar-child-popup>
      </div>
    }
  </div>
}